import React from 'react'
import styled from 'styled-components'
import theme from '@shared/utils/theme'
import { useNavigate } from 'react-router'
import Icon from '@shared/components/Icon'

const PageHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  color: ${ theme.palette.dark_blue };
  font-size: 20px;
  line-height: 23px;
  font-weight: bold;
  align-items: center;
  margin: 10px 20px 40px; 20px;
  .back-btn{
    cursor: pointer;
    margin-top: 2px;
    fill: ${ theme.palette.black };
  }
`

function PageHeader({ children, prevLink, onPrevious }) {
  const navigate = useNavigate()
  return (
    <PageHeaderContainer>
      {
        (prevLink || onPrevious) &&
        <Icon className="back-btn"
              name="chevron_left"
              onClick={ () => {
                onPrevious && onPrevious()
                prevLink && navigate(prevLink)
              } }
        />
      }
      { children }
    </PageHeaderContainer>
  )
}

export default PageHeader
